import axios from "axios";
import { store } from "../../config/store";
import { getCompanyToken, getCurrentCompanyInfo } from "../../utils/companySession";

const getAllEvent = async () => {
  const { userInfo } = store.getState();
  const companyInfo = getCurrentCompanyInfo(userInfo);
  const validCompanyToken = getCompanyToken(companyInfo);

  const headersList = {
    Accept: "*/*",
    "Authorization": "Bearer " + validCompanyToken,
  };
  const reqOptions = {
    url: "https://api.sport909.com/api/Home/events-from-companies",
    method: "GET",
    headers: headersList,
  };
  const response = await axios.request(reqOptions);
  return response.data;
};

const getOdd = async (eventId) => {
  const headersList = {
    Accept: "*/*",
    "X-RapidAPI-Key": "3ad764bb93mshf7de493ea6e7664p10b7a8jsn0320ceb6b535",
    "X-RapidAPI-Host": "betsapi2.p.rapidapi.com",
  };
  const reqOptions = {
    url: `https://betsapi2.p.rapidapi.com/v3/bet365/prematch?FI=${eventId}`,
    method: "GET",
    headers: headersList,
  };
  const response = await axios.request(reqOptions);
  return response.data;
};

const getResult = async (eventId) => {
  const headersList = {
    Accept: "*/*",
    "X-RapidAPI-Key": "3ad764bb93mshf7de493ea6e7664p10b7a8jsn0320ceb6b535",
    "X-RapidAPI-Host": "betsapi2.p.rapidapi.com",
  };

  const reqOptions = {
    url: `https://betsapi2.p.rapidapi.com/v1/bet365/result?event_id=${eventId}`,
    method: "GET",
    headers: headersList,
  };

  const response = await axios.request(reqOptions);
  return response.data;
};

const timeStatusResults = ["NOT START", "INPLAY", "TO BE FIXED", "ENDED", "POSTPONED", "CANCELLED", "WALKOVER", "INTERRUPTED", "ABANDONED", "RETIRED" ];

export { getAllEvent, getOdd, getResult, timeStatusResults };
